// extracted by mini-css-extract-plugin
module.exports = {"EditorReferrals":"_2_amIcmn","titleBlock":"_159rAX0Y","contentBlock":"OF2nOFKX","title":"_3wimfVY1","titleContainer":"_36i0qdx-"};
    if(module.hot) {
      // 1746735834353
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  